import React from 'react';
export const ProfilPage: React.FC = () => {
  return <>
      <section className="w-full bg-white pb-12 px-6 md:px-12 lg:px-20" style={{
      paddingTop: '50px'
    }} data-id="element-649">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-650">
          <div data-id="element-651">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6" data-id="element-652">
              Veränderung mit Potenzial
            </h1>
          </div>
          <div className="flex justify-end items-end" data-id="element-653">
            <img src="https://cdn.magicpatterns.com/uploads/mkMMuqG2BMFR7CF8jHfpQL/Eva-Schifferer.png" alt="Eva Schifferer" className="object-contain" style={{
            maxHeight: 'calc(100% + 48px)',
            marginBottom: '-48px'
          }} data-id="element-654" />
          </div>
        </div>
      </section>
      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-655">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-656">
          <div data-id="element-657">
            <p className="mb-6 text-lg" data-id="element-658">
              Potenziale zu entdecken, zu entwickeln und Veränderungen zu
              gestalten ist mein Kerngeschäft seit über 20 Jahren. In der{' '}
              <span className="text-orange-500" data-id="element-659">Karriereentwicklung</span>, bei{' '}
              <span className="text-orange-500" data-id="element-660">
                anspruchsvollen Führungssituationen
              </span>{' '}
              oder{' '}
              <span className="text-orange-500" data-id="element-661">
                Veränderungen in der Organisation
              </span>{' '}
              mache ich Erfolgsfaktoren und Ressourcen für meine Kunden
              zugänglich um Veränderung erfolgreich anzustoßen.
            </p>
            <p className="mb-6 text-lg" data-id="element-662">
              Bei wichtigen Entscheidungen oder anstehenden Veränderungen
              fördern wir gemeinsam einen klaren Blick sowie Sicherheit über die
              nächsten Schritte.
            </p>
          </div>
          <div data-id="element-663">
            <p className="mb-6 text-lg" data-id="element-664">
              Als Diplom-Psychologin bringe ich wissenschaftliche Erkenntnisse,
              Logik und Intuition in die Beratung aus rund 20 Jahren
              Berufserfahrung als Führungskraft, Expertin und Beraterin in
              internationalen Konzernen sowie im Mittelstand ein. Meine
              Arbeitssprachen sind deutsch und englisch.
            </p>
            <p className="mb-6 text-lg" data-id="element-665">
              Dies macht meinen Beratungsansatz so individuell, wie es meine
              Kunden auch sind.
            </p>
          </div>
        </div>
      </section>
    </>;
};